export default "<div [ngClass]=\"isCustomized ? 'customized-loader-container' : 'loader-container'\">\r\n    <div class=\"loader\"></div>\r\n</div>"